import * as _ from 'underscore';

import { Module } from '../Module';

Module.instance().directive('tbWindowResize', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const resizeFn = $parse(attr['tbWindowResize']);
        const win = angular.element(window);
        const eventNamespace = '.tbWindowResize' + scope.$id;

        const lazyResizeFn = _.debounce(() => {
          scope.$apply(resizeFn(scope));
        }, 50);

        win.on('resize' + eventNamespace, () => {
          lazyResizeFn();
        });

        element.on('$destroy', () => {
          win.off(eventNamespace);
        });
      }
    };
  }
]);
